import React from 'react'
import Images from '../images'

export default function Footer() {
  return (
    <footer id="w_footer" className="section">
      <div className="container level">
        <div className="level-item has-text-centered">
          <div>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.google.com/maps/dir/Current+Location/Korpa+Zdravlja">
              <img
                src={Images.MapPin}
                className="footer_icon"
                alt="Kopra zdravlja - Mapa"
              />
              <p>Donje Moštre 71305 Visoko, BiH</p>
            </a>
          </div>
        </div>

        <div className="level-item has-text-centered">
          <div>
            <a href="tel:+38762224146">
              <img
                src={Images.Phone}
                className="footer_icon"
                alt="Kopra zdravlja - Telefon"
              />
              <p>062-573-375</p>
            </a>
          </div>
        </div>

        <div className="level-item has-text-centered">
          <div>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.facebook.com/profile.php?id=61560191135288">
              <img
                src={Images.FbLogo}
                className="footer_icon"
                alt="Sadi.ba - Facebook"
              />
              <p>Facebook</p>
            </a>
          </div>
        </div>

        <div className="level-item has-text-centered">
          <div>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.instagram.com/sadi.ba.2026/">
              <img
                src={Images.InstagramLogo}
                className="footer_icon"
                alt="Sadi.ba - Instagram"
              />
              <p>Instagram</p>
            </a>
          </div>
        </div>

        <div className="level-item has-text-centered">
          <div>
            <a href="mailto:info@sadi.ba">
              <img
                src={Images.Email}
                className="footer_icon"
                alt="Sadi.ba - Email"
              />
              <p>info@sadi.ba</p>
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}
